import * as React from "react";

;
export const CheckedCheckbox = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="#3FD899" {...props}><rect width={16} height={16} rx={4} /><path stroke="#fff" strokeWidth={1.5} d="M12.5 4.25c-2.391 1.978-4.98 4.483-6.007 7.5H6.2C5.75 10.386 4.625 9.364 3.5 8.838" /></svg>;